import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Resonance",
    img: "https://images.unsplash.com/photo-1565103001988-2de7a0a7c7f7?q=80&w=1400&auto=format&fit=crop",
    alt: "Drum circle in full rhythm",
    text: "Every great event has a pulse. We find it with drums, rhythm circles and shared energy — moments where a room of strangers becomes one beating heart.",
  },
  {
    num: "02",
    title: "Venue Alchemy",
    img: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=1400&auto=format&fit=crop",
    alt: "Grand event venue bathed in light",
    text: "A venue is raw ore. Through production design, lighting and sound we refine it into gold — spaces that don't just host your event, they become it.",
  },
  {
    num: "03",
    title: "Curated Maestros",
    img: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?q=80&w=1400&auto=format&fit=crop",
    alt: "Guitarist performing on stage",
    text: "The right artist changes everything. We manage bands and performers with obsessive care, matching sound to soul for every stage we build.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 sm:py-36 px-6 lg:px-10 bg-[#0d0d10]"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <span
            data-testid="manifesto-eyebrow"
            className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#d4af37] font-semibold mb-4 block"
          >
            The Manifesto
          </span>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white max-w-3xl leading-tight">
            Three chapters of <span className="gold-text">how we work</span>
          </h2>
        </Reveal>

        <div className="mt-20 flex flex-col gap-24">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.num}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <Reveal delay={0}>
                <div className="spotlight-frame overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.alt}
                    loading="lazy"
                    className="w-full aspect-[4/3] object-cover hover:scale-105 transition-transform duration-[1200ms] ease-out"
                  />
                </div>
              </Reveal>
              <Reveal delay={1}>
                <span className="font-cinzel gold-text text-6xl sm:text-7xl font-bold block mb-4">
                  {c.num}
                </span>
                <h3 className="font-serif-display text-3xl sm:text-4xl font-bold text-white mb-5">
                  {c.title}
                </h3>
                <p className="text-base text-zinc-400 leading-relaxed max-w-md">
                  {c.text}
                </p>
                <span className="mt-8 block w-24 h-px bg-gradient-to-r from-[#d4af37] to-transparent" />
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
